
import React from 'react';
import styled from 'styled-components';
import up from '../../assets/up.png';
import SeaLevel from '../../components/SeaLevel/SeaLevel';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';

const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:300px;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

    @media (max-width: 768px) {
    height: 60vh;

  }
`;


class CardSealv extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
              
      <SeaLevel/>
      
            
    </Viz>
    <ReusableDetailCard
   trend= {up}
   metricsm="3.3mm per year"
   diagnosis="Ocean temperatures are increasing, leading to ocean expansion. And as ice sheets and glaciers melt, they add more water."
   prediction="By the end of the century, global mean sea level is likely to rise at least one foot (0.3 meters) above 2000 levels, regardless of emissions reductions in the near future (NOAA)."
   significanceorthreat="THREAT"
   confidence="CONFICENCE LV: 95%"
   />

  </Container>
  );
 }
}
export default CardSealv;
